import { computed, effect, inject, Injectable, signal } from '@angular/core';
import { TestingAccessService } from './testing-access.service';

export enum GiactTestMode {
    REAL_API = 'real_api',
    MOCK_SUCCESS = 'mock_success',
    MOCK_FAIL = 'mock_fail',
    MOCK_ERROR = 'mock_error',
}

@Injectable({
    providedIn: 'root',
})
export class GiactTestToggleService {
    private readonly STORAGE_KEY = 'isi-dtc-giact-test-mode';
    private testingAccess = inject(TestingAccessService);

    testMode = signal<GiactTestMode>(GiactTestMode.REAL_API);

    isRealApi = computed(() => this.testMode() === GiactTestMode.REAL_API);
    isMockSuccess = computed(() => this.testMode() === GiactTestMode.MOCK_SUCCESS);
    isMockFail = computed(() => this.testMode() === GiactTestMode.MOCK_FAIL);
    isMockError = computed(() => this.testMode() === GiactTestMode.MOCK_ERROR);

    constructor() {
        if (this.testingAccess.isEnabled()) {
            this.initializeState();

            effect(() => {
                const mode = this.testMode();
                localStorage.setItem(this.STORAGE_KEY, mode);
            });
        }
    }

    private initializeState(): void {
        const stored = localStorage.getItem(this.STORAGE_KEY);
        if (stored && Object.values(GiactTestMode).includes(stored as GiactTestMode)) {
            this.testMode.set(stored as GiactTestMode);
        }
    }

    setMode(mode: GiactTestMode): void {
        this.testMode.set(mode);
    }
}
